/**
 * Glossary Card Component
 *
 * Handles the expand/collapse functionality for glossary cards.
 * The visibility of the toggle button is controlled server-side via PHP.
 */
(function () {
  'use strict';

  /**
   * Initialize a single glossary card
   * @param {HTMLElement} card - The glossary card element
   */
  function initCard(card) {
    const toggleBtn = card.querySelector('[data-glossary-toggle]');

    if (!toggleBtn) return;

    /**
     * Toggle expanded state
     */
    function toggleExpanded() {
      const isExpanded = card.dataset.expanded === 'true';
      const newState = !isExpanded;

      card.dataset.expanded = String(newState);
      toggleBtn.setAttribute('aria-expanded', String(newState));
    }

    // Handle toggle click
    toggleBtn.addEventListener('click', toggleExpanded);
  }

  /**
   * Initialize all glossary cards on the page
   */
  function init() {
    const cards = document.querySelectorAll('[data-glossary-card]');

    if (cards.length === 0) return;

    cards.forEach(initCard);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
